<template>
  <div class="nav-search-area align-items-center py-3" >
  	<div class="search-area-icon-holder d-flex justify-content-center"><span class="search-area-icon"></span></div>
  	<input-with-placeholder-label inputType="text" labelText="Search" id="main-search-box" class="pr-3" :bigSearch="true" />
  	<h-button class="nav-search-area-submit">Submit</h-button>
	<button id="search-close-button" class="close-icon-holder" aria-label="Close search menu"><span class="bg-icon close-icon"></span></button>
  </div>
</template>

<script>
	import InputWithPlaceholderLabel from '../components/InputWithPlaceholderLabel.vue';
	import HButton from '../components/HButton.vue';
export default {
	components: {
		InputWithPlaceholderLabel,
		HButton
	}
}
</script>

<style lang="scss">

	.nav-search-area {
		padding-right: 9px;
		
		.search-area-icon-holder {
			-ms-grid-column: 1;
		}
		#main-search-box {
			-ms-grid-column: 2;
		}
		.nav-search-area-submit {
			-ms-grid-column: 3;
		}
		.close-icon-holder {
			-ms-grid-column: 4;
		}

		background-color: $white;
		width: 100%;

		display: grid;
		grid-template-columns: 64px 1fr 210px 45px;
		grid-gap: 6px;
		height: 90px;
		z-index: 20;
		@include respond-below(md) {
			grid-template-columns: 50px 1fr 80px 40px;
			grid-gap: 4px;
		}

		.input-with-placeholder-label {
			width: 100%;
			margin-top: 0;
			top: 10px;

			input {
				padding: 10px;

				height: 40px;
				position: relative;
				margin-left: -10px;
			}

		}
		.input-with-placeholder-label--big label {
    		top: -7px;
    	}

		.nav-search-area-submit {
			width: 200px;

			@include respond-below(md) {
				width: 80px;
    			padding: 8px 0;
			}
		}

		.search-area-icon {
			background-image: get-icon( 'search-icon', $black );
			background-repeat: no-repeat;
			width: 33px;

			height: 33px;

			position: relative;
			transition: transform 0.2s;

			@include respond-below(md) {
				width: 25px;
				height: 25px;
			}

		}

		.close-icon-holder {
			background: none;
			border: 0;
			.close-icon {
				background-image: get-icon( 'close-icon', $black );
				width: 28px;
				height: 28px;
				position: relative;
				transition: transform 0.2s;
				@include respond-above(md) {
					width: 100%;
				}


				@include respond-below(md) {
					width: 20px;
					height: 20px;
				}
			}

			&:hover .close-icon {
				background-image: get-icon( 'close-icon', $orangeText );
				transform: translateY(-3px);
			}


		}



	}
</style>
